import { SaveFormButton } from "melco-shared-logic";
import { AddFormButton } from "../form/AddFormButton";

export type FormMode = "add" | "edit";

type AddOrSaveButtonProps = {
  formMode: FormMode;
  disabled?: boolean;
};

export const AddOrSaveButton: React.FC<AddOrSaveButtonProps> = ({
  formMode,
  disabled,
}) => {
  if (formMode === "add") {
    return <AddFormButton disabled={disabled} />;
  }

  return <SaveFormButton disabled={disabled} />;
};
